module.exports = __webpack_public_path__ + "static/bell-f3e1419df2a1ac00aadeb8d1b62fe4c7.mp3";